import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-grid-system';
import HeaderTable from '../../../components/HeaderTable';
import SportTableWrapper from './SportTableWrapper';

export class FavouritesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      sportDate, sportDay, dictionary, sportsForDay, date, isMobile, isDeskFav,
    } = this.props;
    return (
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Row style={{ marginLeft: 0, marginRight: 0 }}>
          <Col md={12} sm={12} xs={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <HeaderTable
              title={sportDate}
              bgColor="mainColorDark"
            />
          </Col>
        </Row>
        {sportsForDay && sportsForDay.map((currentSport, index) => (
          <Row key={index} style={{ margin: '0px' }}>
            <Col md={12} sm={12} xs={12} style={{ padding: '0px' }}>
              <SportTableWrapper
                actions={this.props.actions}
                competitions={sportDay.get(currentSport)}
                key={index}
                dictionary={dictionary}
                sportId={currentSport}
                date={date}
                isMobile={isMobile}
                isDeskFav={isDeskFav}
              />
            </Col>
          </Row>
          ))
        }
      </Container>
    );
  }
}

FavouritesTable.propTypes = {
  sportDate: PropTypes.any,
  dictionary: PropTypes.any,
  sportsForDay: PropTypes.any,
  date: PropTypes.any,
  actions: PropTypes.any,
  sportDay: PropTypes.any,
  isMobile: PropTypes.bool,
  isDeskFav: PropTypes.bool,
};

export default FavouritesTable;
